import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierLisLockIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20 9H18V8C18 4.69 15.31 2 12 2C8.69 2 6 4.69 6 8V9H4C3.45 9 3 9.45 3 10V21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21V10C21 9.45 20.55 9 20 9ZM13.82 16.02C13.82 17.02 13 17.84 12 17.84C11 17.84 10.18 17.02 10.18 16.02V14.98C10.18 13.98 11 13.16 12 13.16C13 13.16 13.82 13.98 13.82 14.98V16.02ZM16 9H8V8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8V9Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierLisLockIcon.displayName = 'HierLisLockIcon';
